/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionNativeOperationKind } from './EmployeeExecutionNativeOperationKind';
/**
 * Persisted retry and audit state for one native operation.
 */
export type EmployeeExecutionNativeOperationAttempt = {
    /**
     * Stable idempotency key for one operation within an execution.
     */
    operationKey: string;
    /**
     * Deterministic operation kind tracked by the runtime.
     */
    operationKind: EmployeeExecutionNativeOperationKind;
    /**
     * Number of execution attempts already reserved for this operation.
     */
    attemptCount: number;
    /**
     * Current persisted lifecycle state of the attempt group.
     */
    status: EmployeeExecutionNativeOperationAttempt.status;
    /**
     * ISO timestamp of the latest attempt-state transition.
     */
    updatedAt: string;
    /**
     * Ephemeral owner of the currently executing reconciliation.
     */
    claimId?: string;
    /**
     * Latest non-empty failure reason when the operation did not succeed.
     */
    lastError?: string;
    /**
     * Stable created or updated resource identifier after success.
     */
    resultReference?: string;
};
export namespace EmployeeExecutionNativeOperationAttempt {
    /**
     * Current persisted lifecycle state of the attempt group.
     */
    export enum status {
        SUCCEEDED = 'succeeded',
        BLOCKED = 'blocked',
        IN_PROGRESS = 'in-progress',
    }
}

